import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";
import {animate, style, transition, trigger} from "@angular/animations";


@Component({
    selector: 'efast-filter-zipcode',
    templateUrl: 'efast-filter-zipcode.component.html',
    styleUrls: ['efast-filter-zipcode.component.css'],
    standalone: false
})

export class EfastFilterZipcodeComponent extends EfastFilterBaseComponent implements OnInit {

    rangeToLbl: string;
    rangeTitle: string;
    errorMsg: string;
    applyBtn: string;
    applyFromValue: string = "";
    applyToValue: string = "";
    errorFound1: boolean ;
    errorFound2: boolean
    fieldFromId: string;
    fieldToId: string;
    rangeTitleId: string;
    curQueryValue: QueryValue = new QueryValue();

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {

        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERZipcodeTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().ZIPCODE;


        this.rangeToLbl = this.cacheService.getLabelFromResource('FILTER:FILTERZipcodeTo');
        this.rangeTitle = this.cacheService.getLabelFromResource('FILTER:FILTERZipcodeRangeTitle');
        this.applyBtn = this.cacheService.getLabelFromResource('FILTER:FILTERZipcodeApplyBtn');
        this.errorMsg = this.cacheService.getLabelFromResource('messages:msg.invalidRange');
        this.rangeTitleId = "zipCodeRangeId";
        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    apply() {
        this.errorFound1 = false;
        this.errorFound2 = false;
        this.applyFromValue = this.cleanField(this.applyFromValue);
        this.applyToValue = this.cleanField(this.applyToValue);

        if ((this.applyFromValue.trim().length != 0) || (this.applyToValue.trim().length != 0)) {
            if (this.applyFromValue.trim() != "*") {
                if (isNaN(Number(this.applyFromValue.trim()))) {
                    this.errorFound1 = true;
                } else {
                    if (this.applyToValue.trim().length == 0) {
                        this.applyToValue = this.applyFromValue;
                    }
                    if (this.applyFromValue.trim().length == 0) {
                        this.applyFromValue = "0";
                    }

                }
            }
            if (!this.errorFound1) {
                if (this.applyToValue.trim() != "*") {
                    if (isNaN(Number(this.applyToValue.trim()))) {
                        this.errorFound2 = true;
                    } else {
                        if (this.applyFromValue.trim().length == 0) {
                            this.applyFromValue = "0";
                        }
                        if (this.applyToValue.trim().length == 0) {
                            this.applyToValue = "0";
                        }
                    }
                }
            }

            if ((!this.errorFound1) && (!this.errorFound2)) {
                this.errorFound1 = false;
                this.errorFound2 = false;
                let queryValue: QueryValue = new QueryValue();
                queryValue.value = this.generateDynamicQueryValue();
                queryValue.displayValue = this.generateDynamicQueryDisplayValue();
                this.curQueryValue = this.queryManagerService.updateOrAdd(this.curQueryValue, queryValue,
                    this.staticsService.getCategoryType().ZIPCODE, true);
            }
        }
    }

    private generateDynamicQueryValue() : string {
        return "[" + this.applyFromValue.trim() +  " TO " + this.applyToValue.trim() + "]";
    }

    private generateDynamicQueryDisplayValue() : string {
        return this.applyFromValue.trim() +  " TO " + this.applyToValue.trim();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {
        super.searchChangeEvent();
        if (!this.queryManagerService.isQueryCategoryInManager(this.staticsService.getCategoryType().ZIPCODE)){
            //clean yourself
            this.applyFromValue = "";
            this.applyToValue= "";
            this.errorFound1 = false;
            this.errorFound2 = false;
        }
    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue);

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().ZIPCODE, this.queryValue, true)
    }
}